"use strict";
exports.__esModule = true;
exports.DEFAULT_BASE_URL_CODE_BY_APPSPACE_AND_WIDGET_TYPE = exports.ENETPULSE_WIDGET_TYPE_OPTIONS = exports.SPORT_OPTIONS = exports.BASE_URL = exports.BASE_URL_PARSER = exports.SCRIPT_REGEX = void 0;
var utilities_1 = require("../../../utilities/utilities");
exports.SCRIPT_REGEX = /<script\s+.+src="(.+)">\s*<\/script>/m;
exports.BASE_URL_PARSER = /(https:\/\/[a-z.]+\/[A-Z0-9]+)\/{0,1}.*/;
exports.BASE_URL = 'https://widget.enetscores.com/{{widgetCode}}';
exports.SPORT_OPTIONS = [
    { label: 'Alpine', value: '6' },
    { label: 'Biathlon', value: '7' },
    { label: 'Bobsleigh', value: '8' },
    { label: 'Cross Country Skiing ', value: '9' },
    { label: 'Curling', value: '10' },
    { label: 'Figure skating', value: '11' },
    { label: 'Freestyle Skiing', value: '12' },
    { label: 'Ice hockey', value: '5' },
    { label: 'Luge', value: '13' },
    { label: 'Nordic combined', value: '14' },
    { label: 'Short Track Speed Skating', value: '15' },
    { label: 'Skeleton', value: '16' },
    { label: 'Ski Jumping', value: '17' },
    { label: 'Snowboarding', value: '18' },
    { label: 'Speed skating', value: '19' },
];
exports.ENETPULSE_WIDGET_TYPE_OPTIONS = [
    {
        label: utilities_1.__('Kalendár podujatí'),
        value: 'eventsCalendar'
    },
    {
        label: utilities_1.__('Výsledky (livecenter)'),
        value: 'livecenter'
    },
    {
        label: utilities_1.__('Tabuľka medailí'),
        value: 'medalTable'
    },
];
// defaultne URLs v <script> tagu podla typu widgetu pre konkretny appSpace
// sluzi ako default pre predvyplnenie formulara
exports.DEFAULT_BASE_URL_CODE_BY_APPSPACE_AND_WIDGET_TYPE = {
    'sportnet.sme.sk': {
        eventsCalendar: {
            sourceCode: 'https://widget.enetscores.com/FW6200D2F6499D8CA4'
        },
        livecenter: {
            sourceCode: 'https://widget.enetscores.com/FW96125A5BEF1476C3'
        },
        medalTable: {
            sourceCode: 'https://widget.enetscores.com/FWCEA55A9407676143'
        }
    }
};
